import { render, staticRenderFns } from "./XSelectCombobox.vue?vue&type=template&id=20d80d46"
import script from "./XSelectCombobox.vue?vue&type=script&lang=js"
export * from "./XSelectCombobox.vue?vue&type=script&lang=js"
import style0 from "./XSelectCombobox.vue?vue&type=style&index=0&id=20d80d46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports